export const getImageMetaAsync = async (url) => {
  const img = new Image();
  img.src = url;
  await img.decode();
  return img;
};
